import buildLinks from '../graphql/traits/buildLinks'

import GraphQLRequest from 'Utilities/GraphQLClient/GraphQLClient'

const LazyLoadFacets = async (existingData) => {
  try {
    const lazyLoadedFacets = existingData.searchResponseFacets?.filter((x) => x.lazyLoaded) ?? []
    if (!lazyLoadedFacets?.length) {
      return { data: existingData, hasNewData: false }
    }
    existingData.lazyLoadedFacetsHydrated = false
    const linkRequests = []

    let index = 0
    for (let i = 0, ilen = lazyLoadedFacets.length; i < ilen; i++) {
      for (let j = 0, jlen = lazyLoadedFacets[i].searchResponseFacetOptions.length; j < jlen; j++) {
        lazyLoadedFacets[i].searchResponseFacetOptions[j].linkRequest.requestIdentifier = index
        index++
        linkRequests.push(lazyLoadedFacets[i].searchResponseFacetOptions[j].linkRequest)
      }
    }

    const response = await GraphQLRequest('/graphql/trait', buildLinks, {
      linkRequests,
    })
    index = 0

    const linkDictionary = Object.fromEntries(response.buildLinks.map((x) => [x.requestIdentifier, x]))
    for (let i = 0, ilen = lazyLoadedFacets.length; i < ilen; i++) {
      for (let j = 0, jlen = lazyLoadedFacets[i].searchResponseFacetOptions.length; j < jlen; j++) {
        const link = linkDictionary[index]
        index++
        lazyLoadedFacets[i].searchResponseFacetOptions[j].linkRequest = null
        if (link?.isValid) {
          lazyLoadedFacets[i].searchResponseFacetOptions[j].facetOptionLink = link
        }
      }
      lazyLoadedFacets[i].lazyLoaded = false
    }
    // note that this will trigger a rerender of all facets
    // usePrpStore(x => x.facetData[facetId]) so that only the things that need to rerender do (vs all facets)
    // perhaps it could be index based also? but for now let's not over engineer...
    existingData.searchResponseFacets = existingData.searchResponseFacets.filter((x) =>
      x.searchResponseFacetOptions.filter((y) => y.facetOptionLink),
    )
    existingData.lazyLoadedFacetsHydrated = true
  } catch (err) {
    console.error('error lazy loading facets', err)
  }

  return { data: existingData, hasNewData: true }
}

export default LazyLoadFacets
